import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {ellipsis} from '../../../../libs/shared/ui/src/styles/mixins';

/*
 * Style.
 */

const StyledSecondaryDiv = styled.div`
  grid-area: secondary-content;
  justify-self: stretch;
  margin-left: 6px;
  max-width: 100%;

  color: ${(p) => p.theme.greys.shade70};
  line-height: 20px;
  ${ellipsis()};
`;

/*
 * Component.
 */

export const DropdownItemSecondaryContent: FC<PropsWithChildren<unknown>> = ({children}) => (
  <StyledSecondaryDiv>{children}</StyledSecondaryDiv>
);
